import { takeLatest, put, call } from 'redux-saga/effects';

import { unlinkUserProject } from '../actions/unlinkUserProject';
import { unlinkProject, unlinkProjectSuccess, unlinkProjectFailure } from '../slices/unlinkProjectSlice';

function* unlinkProjectAction(action:any):Generator<any, void, string> {
  try {
    console.log(action.payload)
    const { tenantId, objectId,projectId } = action.payload;
    // Call the unlinkUserProject API function with the tenantId and objectId and projectId
    const projectDetails:any = yield call(unlinkUserProject, tenantId, objectId,projectId); 
    // Dispatch the unlinkProjectSuccess action with the user data
    yield put(unlinkProjectSuccess(projectDetails));
  } catch (error:any) {
    // If there is an error, dispatch the unlinkProjectFailure action with the error message
    yield put(unlinkProjectFailure(error.message));
  }
}

// Watcher saga
function* unlinkProjectSaga() {
  // Listen for the unlinkProject action and call the unlinkProjectaction saga when dispatched
  yield takeLatest(unlinkProject.type, unlinkProjectAction);
}

export default unlinkProjectSaga;